// the css is injected automatically
// require('!style-loader!css-loader!postcss-loader!stylus-loader!./regnr.styl');

var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).regnr;
var parsing = require('parsing').regnr;
var moduleHelper = require('../../scripts/module-helper');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

function parse(text, next) {
    strip(require('raw!./regnr.html'), function(outputHtml) {
        var match = parsing.parse(text);

        if (match) {
            if (match[1] == "*") {
                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var domObj = container.firstChild;
                var input = domObj.getElementsByTagName("input")[0];
                input.setAttribute("data-required", "true");

                // add a "required" class to the parent node
                domObj.setAttribute("class", domObj.getAttribute("class") + " required");

                outputHtml = container.innerHTML;
            }
            text = text.replace(match[0], outputHtml);
        }

        next(text);
    });

};

function validate(context, err) {
    var input = context.querySelector("input");
    var value = input.value;
    var required = input.getAttribute("data-required") == "true";

    var validationResult = !err ? validation.validate(value, required) : err;

    var currentClasses = input.getAttribute("class") || "";
    currentClasses = currentClasses.replace(/(|\s)valid(|\s)/g, "").replace(/(|\s)error(|\s)/g, "");

    var messagelabel = context.querySelector("#txt_regnr-error");
    messagelabel.innerHTML = "";

    if (!validationResult.valid) {
        input.setAttribute("class", currentClasses + " error");
        var message = document.createTextNode(input.getAttribute("data-msg-required"));
        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " error");
    }
    else {
        input.setAttribute("class", currentClasses + " valid");
        var message = document.createTextNode(input.getAttribute("data-msg-valid"));
        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " valid");
    }

    return validationResult.valid;
}

function init(formRoot, meta, next) {
    var context = formRoot.querySelector('[data-module="regnr"]');

    if( context ) {
        moduleHelper.fields.text.bindValidationEvents(context, validate);
    }

    next(formRoot);
}

function get(context) {
    var input = context.querySelector("input");
    var value = input.value;
    return value;
}

function reset(context) {
    var input = context.querySelector("input");
    input.value = '';
}

module.exports = {
    parse: parse,
    validate: validate,
    init: init,
    get: get,
    skipCollect: false,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/regnr/regnr.js